// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_3KRbD","suggestions-shown":"_1pBEa","suggestionsShown":"_1pBEa","form-container":"_16bag","formContainer":"_16bag","suggestions":"_2lOqF"};